<app-nav-bar
  (resetClicked)="resetClicked()"
  (menuClicked)="menuClicked()"
  (filtersClicked)="filtersClicked()">
</app-nav-bar>

<mat-sidenav-container>

  <mat-sidenav #threadsSidenav [mode]="getSideNavMode()" class="example-sidenav">
    <app-thread-list #threadList></app-thread-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- <app-time-density class="border"></app-time-density> -->
    <app-main-view></app-main-view>
    <!-- <app-filters class="border"></app-filters> -->
    <!-- <app-date-density class="border"></app-date-density> -->
    <!-- <app-message-display class="border"></app-message-display> -->
  </mat-sidenav-content>

  <mat-sidenav #filtersSidenav [mode]="getSideNavMode()" position="end" class="example-sidenav">
    <app-filters></app-filters>
  </mat-sidenav>

</mat-sidenav-container>
